import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PaymentModeSelector } from './payment-mode-selector';

export const PaymentModeSelectorModule: string = ng
    .module('payment-mode-selector', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('paymentModeSelector', PaymentModeSelector)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/payment-mode-selector/payment-mode-selector.module.ts